import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as _ from 'lodash';
import { SharedService } from 'app/shared/services/shared.service';
import { DemandService } from 'app/shared/services/demand.service';
import { DictionaryService } from 'app/shared/services/dictionary.service';

@Component({
  selector: 'cedato-prebid-demand',
  templateUrl: './prebid-demand.component.html',
  styleUrls: ['./prebid-demand.component.scss'],
})

export class PrebidDemandComponent {
  @Input() bidder: any;
  @Input() parentJSON: string;
  @Input() invalidParentJSON: boolean;
  jsonString: string;
  jsonBackup: string;
  dataLoaded: boolean;
  timeout: number;
  jsonMisconfigured: boolean;
  errorInputs: Array<string>;
  @Output() public onConfigChangeEvent: EventEmitter<any>;


  constructor(private sharedService: SharedService, private demandService: DemandService, private dictionaryService: DictionaryService) {
    this.bidder = {};
    this.parentJSON = null;
    this.invalidParentJSON = false;
    this.jsonString = '{}';
    this.jsonBackup = '{}';
    this.dataLoaded = false;
    this.errorInputs = [];
    this.timeout = 150;
    this.jsonMisconfigured = false;
    this.onConfigChangeEvent = new EventEmitter<any>();

  }

  ngOnChanges(): void {
    if (!this.isBidderAdaptersLoaded()) {
      return;
    }

    this.invalidParentJSON = this.parentJSON === this.dictionaryService.get('INCORRECt_JSON_TEMPLATE');

    if (this.parentJSON && !this.bidder.rebuildJSON) {
      this.parseParentJSON();

    } else {
      delete this.bidder.rebuildJSON;
      this.bidder.currentAdapter = _.cloneDeep(this.bidder.adapters[0]);
      this.jsonFromTemplate();
    }
  }

  jsonFromTemplate(): void {
    this.jsonString = this.generateJSONFromTemplate();

    setTimeout(() => {
      this.onConfigChangeEvent.emit(this.jsonString);
      this.dataLoaded = true;
    }, this.timeout);
  }

  generateJSONFromTemplate() {
    let resp: string = _.cloneDeep(this.bidder.currentAdapter.template);
    for (let i = 0; i < this.bidder.currentAdapter.keys.length; i++) {
      if (!this.bidder.currentAdapter.keys[i]['value'] && this.bidder.currentAdapter.keys[i].hasOwnProperty('defaultVal')) {
        this.bidder.currentAdapter.keys[i]['value'] = _.cloneDeep(this.bidder.currentAdapter.keys[i]['defaultVal']);
      }
      resp = resp.split(`[${this.bidder.currentAdapter.keys[i]['name']}]`).join(this.getFailsafeTemplateValue(this.bidder.currentAdapter.keys[i]['value'], this.bidder.currentAdapter.keys[i]['type']));
    }

    try {
      resp = JSON.stringify(eval(`(${resp})`), null, this.sharedService.formatJSONstring);
    } catch (e) {
      resp = 'Incorrect JSON template.';
    }

    return resp;
  }

  getFailsafeTemplateValue(value, type) {
    return value
      ? value
      : type === 'string'
        ? ''
        : value;
  }

  parseParentJSON(): void {
    let jsonPropsArray: string[];
    const templatePropsArray: string[] = [];
    this.jsonString = _.cloneDeep(this.parentJSON);
    const currentJson: any = this.parseJson();
    jsonPropsArray = this.parseObjectDeep(currentJson);
    if (this.bidder.currentAdapter.macrosKeys) {
      Object.keys(this.bidder.currentAdapter.macrosKeys).forEach(key => {
        for (let i = 0; i < this.bidder.currentAdapter.macrosKeys[key].length; i++) {
          templatePropsArray.push(this.bidder.currentAdapter.macrosKeys[key][i]['path']);
        }
      });
    }

    this.jsonMisconfigured = !this.validateStoredJSON(jsonPropsArray, templatePropsArray.filter(Boolean));
    this.readJSON();
  }

  validateStoredJSON(jsonPropsArray: string[], templatePropsArray: string[]) {
    const jsonFromTemplate: any = JSON.parse(this.generateJSONFromTemplate());
    const jsonFromInput: any = JSON.parse(this.jsonString);
    const templateKeysArray: string[] = this.parseObjectDeep(jsonFromTemplate);
    const jsonKeysArray: string[] = this.parseObjectDeep(jsonFromInput);
    //compare json and template keys
    if (!_.isEqual(templateKeysArray.sort(), jsonKeysArray.sort())) {
      return false;
    }

    for (let i = 0; i < templatePropsArray.length; i++) {
      //compare each macro property key
      if (!jsonPropsArray.includes(templatePropsArray[i])) {
        return false;
      }

      //compare each macro property value type
      if (typeof jsonFromTemplate[templatePropsArray[i]] !== typeof jsonFromInput[templatePropsArray[i]]) {
        return false;
      }
    }

    return true;
  }

  parseObjectDeep(json) {
    const resp: string[] = [];
    let subkeys: string[] = [];
    Object.keys(json).forEach(key => {
      if (typeof json[key] === 'object') {
        subkeys = this.parseObjectDeep(json[key]);
        for (let i = 0; i < subkeys.length; i++) {
          resp.push(`${key}.${subkeys[i]}`);
        }
      } else {
        resp.push(key);
      }
    });
    return resp;
  }

  onValueChanged(name: string, val: any): void {
    this.jsonBackup = _.cloneDeep(this.jsonString);
    const changedProp: any = _.find(this.bidder.currentAdapter.keys, { name });
    if (changedProp) {
      const treatAsString = this.isStringValue(changedProp);
      changedProp.value = val.hasOwnProperty('value')
        ? (treatAsString ? val.value : +val.value)
        : (treatAsString ? val.target.value : +val.target.value);
      this.reBuildJSON();
    }
  }

  reBuildJSON() {
    let json: any = this.parseJson();
    let currentKey: any;

    for (let i = 0; i < this.bidder.currentAdapter.keys.length; i++) {
      currentKey = this.bidder.currentAdapter.keys[i];
      if (this.bidder.currentAdapter.macrosKeys[currentKey.name] && this.bidder.currentAdapter.macrosKeys[currentKey.name].length) {
        _.forEach(this.bidder.currentAdapter.macrosKeys[currentKey.name], (oneMacro) => {
          json = this.setDeepValue(json, oneMacro.path, oneMacro.exactMatch
            ? currentKey.value
            : oneMacro.template.split('[template]').join(currentKey.value));
        });
      }
    }

    setTimeout(() => {
      this.jsonString = JSON.stringify(json, null, this.sharedService.formatJSONstring);
      this.onConfigChangeEvent.emit(this.jsonString);
    }, this.timeout);
  }

  setDeepValue(json: any, path: string, value: string): any {
    const pathArr: string[] = path.split('.');
    let localPath: string;

    if (pathArr.length > 1) {
      localPath = pathArr[0];
      pathArr.shift();
      json[localPath] = this.setDeepValue(json[localPath], pathArr.join(), value);
    } else {
      json[pathArr[0]] = value;
    }
    return json;
  }

  readJSON(): void {
    let currentMacroKey: any;
    let currentKey: any;
    let templateEntries: string[];
    let keyValue: any;
    let tmpKey: any;
    let tmpValue: string;
    const currentJson: any = this.parseJson();
    const tempChar = this.sharedService.generateUniqString(3);
    if (Object.keys(this.bidder.currentAdapter.macrosKeys).length !== 0) {
      Object.keys(this.bidder.currentAdapter.macrosKeys).forEach((one) => {
        currentMacroKey = this.bidder.currentAdapter.macrosKeys[one][0];
        currentKey = _.find(this.bidder.currentAdapter.keys, { name: one });
        tmpKey = currentMacroKey.path.split('.').reduce((o, i) => o && o[i] ? o[i] : null, currentJson);
        keyValue = _.cloneDeep(tmpKey);

        if (currentMacroKey.exactMatch) {
          currentKey.value = this.isStringValue(currentKey) ? keyValue : +keyValue;

        } else {
          templateEntries = currentMacroKey.template.split('[template]');
          if (keyValue) {
            for (let i = 0; i < templateEntries.length; i++) {
              keyValue = keyValue.replace(templateEntries[i], `${tempChar}`);
            }

            if (_.uniq(keyValue.split(tempChar)).filter(Boolean).length > 1) {
              this.jsonMisconfigured = true;

            } else {
              tmpValue = _.uniq(keyValue.split(tempChar)).filter(Boolean)[0];
              tmpValue = this.getFailsafeTemplateValue(tmpValue, currentKey.type);

              if (currentMacroKey.template.split('[template]').join(tmpValue) === tmpKey.split(tempChar).join(tmpValue)) {
                currentKey.value = tmpValue;
              } else {
                this.jsonMisconfigured = true;
              }
            }
          }
        }
      });
    }
  }

  parseJson(): any {
    let currentJson: any;
    try {
      currentJson = eval(`(${this.jsonString})`);

    } catch (e) {
      currentJson = eval(`(${this.jsonBackup})`);
      //this.jsonString = 'Incorrect JSON template.';
    }

    return currentJson;
  }

  getSelectedValue(item): number {
    const lookup = item.optionsType === 'string' ? item.value : +item.value;
    const selected: any = _.find(item.options, { value: lookup });
    return selected
      ? item.options.indexOf(selected)
      : -1;
  }

  // A select whose option values are strings (e.g. seedtag placement) must skip numeric coercion.
  isStringValue(key): boolean {
    return key.type === 'string'
      || (key.type === 'select' && key.optionsType === 'string');
  }

  htmlFriendlyName(name: string): string {
    return name.replace(/\s+/g, '-').toLowerCase();
  }

  isBidderAdaptersLoaded(): boolean {
    return this.bidder && this.bidder.adapters && this.bidder.adapters.length;
  }

  selectItemIndex(): number {
    return this.demandService.chooseAdapter(this.bidder, this.parentJSON);
  }

  onAdapterSelect($event): void {
    this.bidder.currentAdapter = $event;

    if (this.parentJSON && !this.bidder.rebuildJSON) {
      this.parseParentJSON();
    } else {
      delete this.bidder.rebuildJSON;
      this.jsonFromTemplate();
    }
  }

  // On click event
  @HostListener('document:click', ['$event'])
  onDocumentChange($event): void {
    if ($event.target.className && $event.target.className === 'reset-json-config') {
      this.parentJSON = null;
      this.jsonMisconfigured = false;
      this.jsonFromTemplate();
    }
  }
}
